import { ScheduledJobLogRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class ScheduledJobLogService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ScheduledJobLogRouteService());
    }

    findScheduledJobLogs(filter) {
        var url = this.routeService.findScheduledJobLogs(filter);
        return this.apiClient.post(url, findParams(filter));
    }
}

export default ScheduledJobLogService;
